import React from 'react';

interface Props {
  selected: boolean;
  onChange: () => void;
  title: string;
  position?: 'left' | 'right' | 'center';
  disabled?: boolean;
}

import styles from './RadioButton.module.scss';

export const RadioButton: React.FC<Props> = (props) => {
  return (
    <div
      data-position={props.position}
      data-selected={props.selected}
      data-disabled={props.disabled}
      className={styles.container}
      onClick={props.disabled ? undefined : props.onChange}
    >
      {props.title}
    </div>
  );
};
